if (!customElements.get('navarambh-forever')) {
  customElements.define('navarambh-forever', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }

    init() {
      if (!('IntersectionObserver' in window)) return;
      this.classList.add('is-ready');
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.classList.add('is-in');
          this.observer.disconnect();
        }
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
    }
  });
}